import { render, staticRenderFns } from "./ViewFeedback.vue?vue&type=template&id=bd8cdfea&"
import script from "./ViewFeedback.vue?vue&type=script&lang=js&"
export * from "./ViewFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports